module.exports = __webpack_public_path__ + "img/PB01.08286fd8.svg";